// @flow

import React from 'react';
import type { Node } from 'react';
import styled, { css } from 'styled-components';
import type { Theme } from '../../../types';
import {
  grid,
  gridArea,
  gridTemplateRows,
  gridTemplateColumns,
} from '../../../helpers/gridHelpers';
import Link from '../../link';
import {
  Content,
  Header,
  ImageContainer,
} from '../components';
import { TagContainer } from '../../tags';

type ContainerProps = {
  overlay: boolean,
};

export const Container = styled<any, Theme, ContainerProps>('article')`
  /* Disable no-duplicate-selectors because stylelint interprets 'Dollar'{Header} as a div */
  /* stylelint-disable no-duplicate-selectors */
  ${grid()}
  ${gridTemplateRows('12rem 6rem auto minmax(max-content, 1fr)')}
  ${gridTemplateColumns('100%')}
  cursor: pointer;
  height: 100%;
  justify-content: stretch;
  position: relative;

  ${props => props.overlay && css`
    filter: blur(.5px);
  `}

  ${/* sc-sel */ImageContainer} {
    ${gridArea('1 / 1 / 2 / 2')};
  }

  ${/* sc-sel */Header} {
    border-bottom: 1px solid ${props => props.theme.divider.color};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    ${gridArea('2 / 1 / 3 / 2')};
  }

  ${/* sc-sel */Content} {
    ${gridArea('3 / 1 / 5 / 2')};
  }

  ${/* sc-sel */TagContainer} {
    ${gridArea('1 / 1 / 2 / 2')};
    align-self: end;
    padding-bottom: .5rem;
    z-index: 1;
  }

  &:hover {
    img {
      transform: translate(-50%, -50%) scale(1.05);
    }
  }
`;

const ContainerLink = styled<typeof Link, Theme, _>(Link)`
  margin-bottom: 0;
  text-decoration: none;
`;

type Props = {
  children: Node,
  link: string,
  overlay: boolean,
  onClick: Function,
};

export const DefaultContainer = ({
  children, link, overlay, onClick,
}: Props) => (
  <ContainerLink href={link} onClick={onClick}>
    <Container overlay={overlay} data-cy="carblockDefaultContainer">
      {children}
    </Container>
  </ContainerLink>
);

export default null;
